export default __webpack_public_path__ + "static/media/neiman-marcus.130da01c.png";